// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CheckoutStepper from "@awc/App/Components/Checkout/CheckoutStepper";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    homePageUrl: getHomePageUrl(state),
});

export interface OrderConfirmationPageTitleStyles {
    container?: InjectableCss;
    heading?: TypographyPresentationProps;
    continueButton?: ButtonPresentationProps;
}

type Props = HasHistory & WidgetProps & ReturnType<typeof mapStateToProps>;

export const orderConfirmationPageTitleStyles: OrderConfirmationPageTitleStyles = {};

const styles = orderConfirmationPageTitleStyles;

const OrderConfirmationPageTitle: FC<Props> = ({ history, homePageUrl }) => {
    const continueClickHandler = () => {
        history.push(homePageUrl);
    };

    return (
        <>
            <StyledWrapper {...styles.container}>
                <Typography {...styles.heading}>{translate("Checkout")}</Typography>
                <CheckoutStepper currentStep="confirmation" />
            </StyledWrapper>
            <Button {...styles.continueButton} onClick={continueClickHandler}>
                {translate("Continue Shopping")}
            </Button>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(OrderConfirmationPageTitle)),
    definition: {
        displayName: "Page Title",
        allowedContexts: ["OrderConfirmationPage"],
        group: "Order Confirmation",
    },
};

export default widgetModule;
